let finance = {
  name: 'finance',
  path: 'finance',
  redirect: '/finance/index',
  component: () => import('@/views/finance/index.vue'),
  meta: {
    name: '财务'
  },
  children: [
    {
      path: '/finance/index',
      name: 'index',
      component: () => import('@/views/finance/business/index.vue'),
      meta: {
        name: '交易记录'
      }
    },
    {
      path: '/finance/dataStatistics',
      name: 'dataStatisticsIndex',
      component: () => import('@/views/finance/dataStatistics/index.vue'),
      meta: {
        name: '数据统计'
      }
    },
    {
      path: '/finance/business/detail/:id',
      name: 'businessDetail',
      component: () => import('@/views/finance/business/detail.vue'),
      meta: {
        name: '交易详情'
      }
    },
    {
      path: 'youkaRecord',
      name: 'cardindex',
      component: () => import('@/views/finance/youkaRecord/index.vue'),
      meta: {
        name: '优卡记录'
      }
    },
    {
      path: 'drawbackRecord',
      name: 'drawbackindex',
      component: () => import('@/views/finance/drawbackRecord/index.vue'),
      meta: {
        name: '退款记录'
      }
    },
    {
      path: '/finance/drawbackRecord/detail/:id',
      name: 'drawbackDetail',
      component: () => import('@/views/finance/drawbackRecord/detail.vue'),
      meta: {
        name: '退款详情'
      }
    },
    {
      path: 'cashoutRecord',
      name: 'cashoutindex',
      component: () => import('@/views/finance/cashoutRecord/index.vue'),
      meta: {
        name: '回收提现'
      }
    },
    {
      path: 'commission',
      name: 'commissionindex',
      component: () => import('@/views/finance/commission/index.vue'),
      meta: {
        name: '分佣提现'
      }
    },
    {
      path: 'financial',
      name: 'financial',
      component: () => import('@/views/finance/financial/index.vue'),
      meta: {
        name: '财务统计'
      }
    },
    {
      path: 'serviceOrdering',
      name: 'serviceOrdering',
      component: () => import('@/views/finance/serviceOrdering/index.vue'),
      meta: {
        name: '服务订购'
      }
    },
    {
      path: 'serviceOrdering/softwareUse',
      name: 'softwareUse',
      component: () => import('@/views/finance/serviceOrdering/softwareUse.vue'),
      meta: {
        name: '软件分-使用记录'
      }
    },
    {
      path: 'serviceOrdering/softwareBuy',
      name: 'softwareBuy',
      component: () => import('@/views/finance/serviceOrdering/softwareBuy.vue'),
      meta: {
        name: '软件分-购买记录'
      }
    }
  ]
}

export default finance
